import { Store } from 'libx'
import { action, observable, computed } from 'mobx'

export default class DocumentsScreenStore extends Store {
  @observable loading = false

  @computed get documents () {
    return this.rootStore.documentStore.allDocuments
  }

  @action setLoading (loading) {
    this.loading = loading
  }

  async activate () {
    this.setLoading(true)
    try {
      await this.rootStore.documentStore.fetchDocuments()
    } finally {
      this.setLoading(false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/DocumentsScreenStore.js